export const getFortuneWheelAllItems = ({ wheel }) => wheel.allItems;

export const getFortuneWheelItems = ({ wheel }) => wheel.wheelItems;

export const getFortuneWheelResult = ({ wheel }) => wheel.result;

export const getFortuneWheelWinnerModalStatus = ({ wheel }) => wheel.winnerModal;

export const getFortuneWheelAvailability = ({ wheel }) => wheel.availability;
